import * as React from "react";

const SvgVero = (props, ref) => (
  <svg
    fill="none"
    height="1em"
    viewBox="0 0 512 512"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
    {...{ ...props, ref }}
  >
    <linearGradient
      id="Vero_svg__a"
      gradientUnits="userSpaceOnUse"
      x1={524.149}
      x2={215.269}
      y1={182.169}
      y2={199.697}
    >
      <stop offset={0} stopColor="#2936a3" />
      <stop offset={1} stopColor="#162286" />
    </linearGradient>
    <linearGradient
      id="Vero_svg__b"
      gradientUnits="userSpaceOnUse"
      x1={34.059}
      x2={463.954}
      y1={348.61}
      y2={223.408}
    >
      <stop offset={0} stopColor="#2297f4" />
      <stop offset={1} stopColor="#31a0f9" />
    </linearGradient>
    <path
      d="M480.942 265.214c41.411-40.54 41.411-106.269 0-146.809-41.41-40.54-108.55-40.54-149.961 0L256 191.81l74.751 73.179.23.226c41.366 40.497 108.408 40.54 149.829.129z"
      fill="url(#Vero_svg__a)"
    />
    <path
      d="m106.043 338.623-74.985-73.408c-41.41-40.541-41.41-106.269 0-146.809 41.41-40.54 108.551-40.54 149.961 0l74.985 73.408z"
      fill="#17da88"
    />
    <path
      d="M480.942 265.215c-41.411 40.54-108.551 40.54-149.961 0l-.23-.226-74.747-73.175-149.961 146.809 42.842 41.941c59.158 57.915 155.073 57.915 214.231 0z"
      fill="url(#Vero_svg__b)"
    />
  </svg>
);
export default React.forwardRef(SvgVero);
